import spacingScale from './spacingScale';
import screens from './screenSizes';

export default {
  ...spacingScale,

  MOBILE_HORIZONTAL: `0 ${spacingScale.MOBILE_X}px`,
  MOBILE_VERTICAL: `${spacingScale.MOBILE_Y}px 0`,
  MOBILE_T_R_L: `${spacingScale.MOBILE_Y}px ${spacingScale.MOBILE_X}px`,
  MOBILE_SPACING: `${spacingScale.MOBILE_Y}px ${spacingScale.MOBILE_X}px`,
  MOBILE_VERTICAL_SMALL: `0 ${spacingScale.MOBILE_Y_SMALL}px`,
  MOBILE_V_H: `${spacingScale.MOBILE_X_LARGE}px ${spacingScale.MOBILE_Y}px`,
  MOBILE_VERTICAL_LARGE: `0 ${spacingScale.MOBILE_Y_LARGE}px`,


  DESKTOP_HORIZONTAL: `0 ${spacingScale.DESKTOP_X}px`,
  DESKTOP_VERTICAL: `${spacingScale.DESKTOP_Y}px 0`,
  DESKTOP_T_R_L: `${spacingScale.DESKTOP_Y}px ${spacingScale.DESKTOP_X}px 0`,
  DESKTOP_SPACING: `${spacingScale.DESKTOP_Y}px ${spacingScale.DESKTOP_X}px`,

  DESKTOP_HD_HORIZONTAL: `0 ${spacingScale.DESKTOP_HD_X}px`,
  DESKTOP_HD_VERTICAL: `${spacingScale.DESKTOP_HD_Y}px 0`,
  DESKTOP_HD_T_R_L: `${spacingScale.DESKTOP_HD_Y}px ${spacingScale.DESKTOP_HD_X}px 0`,
  DESKTOP_HD_SPACING: `${spacingScale.DESKTOP_HD_Y}px ${spacingScale.DESKTOP_HD_X}px`,
  DESKTOP_HD_T_R_L_XS: `${spacingScale.DESKTOP_HD_Y_XS}px ${spacingScale.DESKTOP_HD_X_XS}px`,


  M_B_0: { marginBottom: 0 },
  M_A_0: { margin: 0 },


  M_B_REGULAR: {
    marginBottom: { marginBottom: spacingScale.DESKTOP.X_LARGE },

    [screens.TABLET]: { marginBottom: spacingScale.MOBILE.X_LARGE },
    [screens.DESKTOP_HD]: { marginBottom: spacingScale.DESKTOP_HD.X_LARGE },
  },

  M_B_XS: {
    marginBottom: spacingScale.MOBILE.X_SMALL,

    [screens.TABLET]: { marginBottom: spacingScale.MOBILE.X_SMALL },
    [screens.DESKTOP_HD]: { marginBottom: spacingScale.MOBILE.X_SMALL },
  },

  M_B_S: {
    marginBottom: spacingScale.MOBILE.SMALL,

    [screens.TABLET]: { marginBottom: spacingScale.DESKTOP.SMALL },
    [screens.DESKTOP_HD]: { marginBottom: spacingScale.DESKTOP_HD.SMALL },
  },

  M_B_M: {
    marginBottom: spacingScale.MOBILE.MEDIUM,

    [screens.TABLET]: { marginBottom: spacingScale.DESKTOP.MEDIUM },
    [screens.DESKTOP_HD]: { marginBottom: spacingScale.DESKTOP_HD.MEDIUM },
  },

  M_B_L: {

    [screens.TABLET]: { marginBottom: spacingScale.MOBILE.LARGE },
    [screens.DESKTOP_HD]: { marginBottom: spacingScale.DESKTOP_HD.LARGE },
  },

  M_B_XL: {
    marginBottom: spacingScale.MOBILE.X_LARGE,

    [screens.TABLET]: { marginBottom: spacingScale.DESKTOP.X_LARGE },
    [screens.DESKTOP_HD]: { marginBottom: spacingScale.DESKTOP_HD.X_LARGE },
  },

  M_B_FOOTER: {
    marginBottom: spacingScale.FOOTER.LARGE,

  },
};



// WEBPACK FOOTER //
// ./src/identity/spacing.js